const vClickOutside = {
  mounted: (
    el: {
      clickOutsideEvent: {
        (event: any): void;
        (this: HTMLElement, ev: MouseEvent): any;
      };
      contains: (arg0: any) => any;
    },
    binding: {
      value: {
        dontTarget: string;
        dontTarget2?: string;
        hidden: boolean;
        function: Function;
      };
    }
  ) => {
    el.clickOutsideEvent = (event) => {
      if (binding.value.dontTarget2 === undefined) {
        if (!binding.value.hidden) {
          if (event.target.id !== binding.value.dontTarget) {
            if (!(el == event.target || el.contains(event.target))) {
              binding.value.function();
            }
          }
        }
      } else {
        if (!binding.value.hidden) {
          if (event.target.id !== binding.value.dontTarget && event.target.id !== binding.value.dontTarget2) {
            if (!(el == event.target || el.contains(event.target))) {
              binding.value.function();
            }
          }
        }
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted: (el: { clickOutsideEvent: (this: HTMLElement, ev: MouseEvent) => any }) => {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
};

export default vClickOutside;
